module.exports = __webpack_public_path__ + "frontend-assets/img/history_icon.bee019ce.png";